import React from "react";
import { Button } from "react-bootstrap";

export type CategoryIconPickerIcon = {
    id: number;
    path?: string | null;
    url?: string | null;
};

export type CategoryIconPickerProps = {
    icons: CategoryIconPickerIcon[];
    value: number | null;
    onChange: (iconId: number | null) => void;
    disabled?: boolean;
    basePath?: string;
};

const buildIconSrc = (icon: CategoryIconPickerIcon, basePath?: string): string => {
    if (icon.url) return icon.url;
    if (!icon.path) return "";
    return basePath ? `${basePath}/${icon.path}` : icon.path;
};

const CategoryIconPicker: React.FC<CategoryIconPickerProps> = ({ icons, value, onChange, disabled, basePath }) => {
    return (
        <div className="category-icons-grid d-grid gap-6 w-100">
            {icons.map((icon) => {
                const isSelected = value === icon.id;
                return (
                    <div key={icon.id} className="align-content-between">
                        <Button
                            type="button"
                            variant={isSelected ? "outline-primary" : "outline-secondary"}
                            className={`d-flex justify-content-center align-items-center p-2 ${
                                isSelected ? "bg-violet" : ""
                            }`}
                            onClick={() => {
                                onChange(isSelected ? null : icon.id);
                            }}
                            disabled={disabled}
                        >
                            <img src={buildIconSrc(icon, basePath)} width={30} height={30} alt="category icon" />
                        </Button>
                    </div>
                );
            })}
        </div>
    );
};

export default CategoryIconPicker;
